/**
 * PasswordInput – slaptažodžio laukas su tikralaikiu stiprumo indikatoriumi.
 * Props: value, onChange, required, placeholder, label, showStrength (default true)
 */

export function validatePassword(pw) {
  return {
    length:    pw.length >= 8,
    uppercase: /[A-Z]/.test(pw),
    lowercase: /[a-z]/.test(pw),
    number:    /[0-9]/.test(pw),
  };
}

export function isPasswordValid(pw) {
  const v = validatePassword(pw);
  return v.length && v.uppercase && v.lowercase && v.number;
}

export default function PasswordInput({ value, onChange, required, placeholder, label, showStrength = true, id }) {
  const rules = validatePassword(value || '');
  const passed = Object.values(rules).filter(Boolean).length;
  const show   = showStrength && value?.length > 0;

  const barColor = passed <= 1 ? '#ef4444' : passed === 2 ? '#f59e0b' : passed === 3 ? '#f59e0b' : '#10b981';
  const barLabel = passed <= 1 ? 'Labai silpnas' : passed === 2 ? 'Silpnas' : passed === 3 ? 'Vidutinis' : 'Stiprus ✅';

  return (
    <div>
      {label && <label className="form-label" htmlFor={id}>{label}</label>}
      <input
        id={id}
        className="form-input"
        type="password"
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder || 'Min. 8 simboliai'}
        autoComplete="new-password"
      />

      {show && (
        <div style={{ marginTop: 8 }}>
          {/* Stiprumo juosta */}
          <div style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
            {[1,2,3,4].map(i => (
              <div key={i} style={{
                flex: 1, height: 4, borderRadius: 2,
                background: i <= passed ? barColor : 'var(--border)',
                transition: 'background 0.2s'
              }} />
            ))}
          </div>
          <div style={{ fontSize: 11, color: barColor, marginBottom: 6, fontWeight: 600 }}>{barLabel}</div>

          {/* Reikalavimai */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 16px' }}>
            {[
              { ok: rules.length,    text: 'Min. 8 simboliai' },
              { ok: rules.uppercase, text: 'Didžioji raidė (A-Z)' },
              { ok: rules.lowercase, text: 'Mažoji raidė (a-z)' },
              { ok: rules.number,    text: 'Skaičius (0-9)' },
            ].map(r => (
              <div key={r.text} style={{ fontSize: 11, color: r.ok ? '#10b981' : '#94a3b8', display: 'flex', alignItems: 'center', gap: 4 }}>
                <span>{r.ok ? '✅' : '○'}</span> {r.text}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
